import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Shell for the COMPANY panel's Marketplace insights section. Title, mode
 * badge, page dropdown and department filter all come from
 * CompanySectionLayout, shared with Sleep, Breathwork and Habit Tracker.
 *
 * NOTE ON THE PATH: /:slug/marketplace is the company's shopping experience
 * (browse, cart, orders) and is linked from the sidebar. These analytics pages
 * therefore live under /:slug/marketplace/insights rather than taking over
 * that route.
 */
const CompanyMarketplaceLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'E-Gifts Dashboard',
      path: `/${slug}/marketplace/insights`,
      description: 'Orders, spend and the brands your people choose'
    },
    {
      label: 'VIP Offers',
      path: `/${slug}/marketplace/insights/vip`,
      description: 'The offer catalogue, and what your people click'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/marketplace/insights/users`,
      description: `Per-${population.replace(/s$/, '')} redemption records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Marketplace"
      subtitle={`What your ${population} redeem, and which offers they reach for.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyMarketplaceLayout;
